<template>
  <!-- 补款审核 -->
  <div>
    <app-page>
      <template #fheader>
        <div class="fan-search margin-bottom-8">
          <jr-search2
            ref="searchForm"
            :form-list="formList"
            :search-value.sync="queryForm"
            :loading="loading"
            @search="handleSearch"
            @reset="handleReset"
            trackCode='approvaSupplementList-1'
          />
        </div>
      </template>
      <template #header>
        <div class="fan-search">
          <page-select-groups :search-value.sync="queryForm" @change="refreshList" :selectList="selectList">
            <template #sourceList>
              <page-source-select
                title="归属业务"
                :sources="queryForm.sourceList"
                @select-change="sourceChange"
              />
            </template>
          </page-select-groups>
          <div class="fan-search-col fan-search-right">
            <!-- 表格数据配置 -->
            <jr-columns-config
              :columnsKey="columnsKey"
              :tableColumn="tableColumn"
              :selectTableColumn="selectTableColumn"
              @confirm="handleConfirm"
            />
            <div style="margin-left: 10px" v-if="$has('FWS-KJSH-BKSH-DC')">
              <page-export-button
                buttonText="导出"
                exportServe="fin_payment_applySuppleReport"
                :total="total"
                :isLimit="true"
                :exportParams="exportParams"
                trackCode='approvaSupplementList-2'
              />
            </div>
          </div>
        </div>
      </template>
      <template #main="{ height }">
        <jr-table
          :height="height"
          :key="height"
          :loading="loading"
          :tableData="list"
          :tableColumn="selectTableColumn"
          ref="tableListRef"
        >
          <template v-slot:operate="{row}">
            <btns-operate :current="row" @success="getList" :show="['WAIT'].includes(row.approvalStatus)" />
          </template>
        </jr-table>
      </template>
      <template #ffooter>
        <pagination
          :total="total"
          :current-page="queryForm.page"
          :size="queryForm.limit"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </template>
    </app-page>
    <!-- 详情 -->
    <detail
      :visible.sync="isDetailShow"
      :suppleApplyNo.sync="suppleApplyNo"
      @after-done="getList"
    />
  </div>
</template>

<script>
import { getSupplementApplyBopList } from '@/api/supplement';
import detail from './components/detail';
import { setStatusColor } from '@/filters/index';
import btnsOperate from './components/btns-operate';
import { tableColumnsKeys } from '@/utils/constant';

const queryFormDefault = {
  beginTime: '', // 开始时间
  endTime: '', // 结束时间
  page: 1,
  limit: 20,
  contentList: '', // 搜索值
  searchType: '2',
  timeType: '1',
  approvalStatus: '',
  suppleWay: '',
  transType: '2',
  sourceList: [],
};

export default {
  name: 'ApprovaSupplementList',
  components: { btnsOperate, detail },
  data() {
    const list = [
      {
        value: '2',
        label: '业务订单号',
      }, {
        value: '1',
        label: '补款申请编号',
      }, {
        value: '3',
        label: '客户编号',
      },
      {
        value: '4',
        label: '客户名称',
      },
      {
        value: '5',
        label: '申请人',
      },
      {
        value: '6',
        label: '操作人',
      },
    ];
    return {
      loading: false,
      formList: [
        {
          prop: 'timeType',
          component: 'select-date-picker',
          options: [
            { label: '创建日期', value: '1' },
            { label: '操作日期', value: '2' },
          ],
        },
        {
          prop: 'searchType',
          contentProp: 'contentList',
          component: 'search-input-select',
          attrs: {
            type: 'text',
            placeholder: '请输入内容',
          },
          options: list,
        },
      ],
      columnsKey: tableColumnsKeys.approvalSupplementList,
      tableColumn: [
        {
          prop: 'suppleApplyNo',
          label: '补款申请编号',
          minWidth: '1',
          disabled: true,
          permission: 'FWS-KJSH-BKSH-XQ',
          trackCode: 'approvaSupplementList-6',
          click: (row) => {
            this.handleDetail(row);
          },
        },
        { prop: 'origTransNum', label: '业务订单号', minWidth: '1' },
        { prop: 'businessNo', label: '客户编号', minWidth: '1' },
        { prop: 'businessName', label: '客户名称', minWidth: '1' },
        { prop: 'sourceDesc', label: '归属业务', minWidth: '1' },
        { prop: 'suppleWayDesc', label: '补款方式', minWidth: '1' },
        { prop: 'suppleAmount', label: '补款申请金额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat', disabled: true },
        { prop: 'suppleReason', label: '补款原因', minWidth: '1', showOverflowTooltip: true },
        { prop: 'createUser', label: '申请人', minWidth: '1' },
        { prop: 'createTime', label: '创建时间', minWidth: '1', filterName: 'formatTime', disabled: true },
        { prop: 'modifyUser', label: '操作人', minWidth: '1' },
        // 审核状态：1、待审核 2、已通过 -1、已驳回 -2、已取消 0、取消中
        {
          prop: 'approvalStatus',
          label: '状态',
          status: 'approvalStatus',
          statusDesc: 'approvalStatusDesc',
          disabled: true,
          statusColor: (val) => setStatusColor(val, 'approvalStatus'),
        },
        { prop: 'operate', label: '操作', width: '165', slotName: 'operate', disabled: true },
      ],
      selectTableColumn: [],
      queryForm: JSON.parse(JSON.stringify(queryFormDefault)),
      list: [],
      total: 0,
      isDetailShow: false, // 详情弹窗
      suppleApplyNo: '',
      selectList: [
        {
          title: '补款方式',
          prop: 'suppleWay',
          dictionaryPath: '/finance/finance-payment/SupplementApprovalWayEnum',
        },
        {
          title: '状态',
          prop: 'approvalStatus',
          dictionaryPath: '/finance/finance-payment/SupplementApprovalStatusEnum',
        },
        {
          slotName: 'sourceList',
        },
      ],
    };
  },
  computed: {
    exportParams() {
      const params = {
        ...this.queryForm,
        contentList: this.queryForm.contentList ? this.queryForm.contentList.split(',') : [],
      };
      delete params.page;
      delete params.limit;
      return params;
    },
  },
  created() {
    this.init();
  },
  methods: {
    sourceChange(list) {
      this.queryForm.sourceList = [...list];
      this.refreshList();
    },
    // 配置确认
    handleConfirm(values) {
      this.selectTableColumn = values;
      this.$nextTick(() => {
        this.$refs.tableListRef.doLayout();
      });
    },
    async init() {
      try {
        const list = await this.$store.dispatch('dictionary/getUserTemplate', {
          pageKeys: [this.columnsKey],
          columnsKey: this.columnsKey,
          tableColumn: this.tableColumn,
        });
        this.selectTableColumn = list;
      } catch (error) {
        this.selectTableColumn = this.tableColumn;
      }
      this.getList();
    },
    // 列表查询
    async getList() {
      try {
        this.loading = true;
        const res = await getSupplementApplyBopList({
          ...this.queryForm,
          contentList: this.queryForm.contentList ? this.queryForm.contentList.split(',') : [],
        });
        this.total = res.totalCount || 0;
        this.list = res.data || [];
      } catch (error) {
        this.list = [];
        this.total = 0;
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    // 分页操作
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(limit) {
      this.queryForm.page = 1;
      this.queryForm.limit = limit;
      this.getList();
    },
    // 列表查询
    handleSearch(params = {}) {
      this.queryForm = {
        ...this.queryForm,
        ...params,
        page: 1,
      };
      this.getList();
    },
    // 重置搜索条件
    handleReset() {
      this.queryForm = JSON.parse(JSON.stringify(queryFormDefault));
      this.getList();
    },
    refreshList() {
      this.queryForm.page = 1;
      this.getList();
    },
    // 详情
    handleDetail(row) {
      this.suppleApplyNo = row?.suppleApplyNo || '';
      this.isDetailShow = true;
    },
  },
};
</script>
